// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"c49a1eea","275":"b05a0fb0","903":"552d1131"}[chunkId] + ".chunk.js";
};